import { cn } from "../../utils";
import { CalendarPanel } from "./CalendarPanel";
import { TimePanel } from "./TimePanel";
import type { DateTimePickerPanelProps } from "./panelTypes";

/** Adapters mapping `DateTimePickerPanelProps` onto the primitive panels. */

/** `variant="datetime"` -- calendar and clock side by side (stacked on mobile). */
export function DateTimePanel({
  field,
  locale,
  weekStartsOn,
  showOutsideDays,
  fixedWeeks,
  captionLayout,
  minuteStep,
  classNames,
  renderDay,
  onEscape,
  autoFocus,
}: DateTimePickerPanelProps) {
  const [hours, minutes] = field.timeParts;

  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:gap-4">
      <CalendarPanel
        field={field}
        locale={locale}
        weekStartsOn={weekStartsOn}
        showOutsideDays={showOutsideDays}
        fixedWeeks={fixedWeeks}
        captionLayout={captionLayout}
        classNames={classNames}
        renderDay={renderDay}
        onEscape={onEscape}
        autoFocus={autoFocus}
      />
      <div
        className={cn(
          "border-t border-border pt-3",
          "sm:border-l sm:border-t-0 sm:pl-4 sm:pt-0",
        )}
      >
        <TimePanel
          hours={hours}
          minutes={minutes}
          minuteStep={minuteStep}
          classNames={classNames}
          onChange={field.selectTime}
        />
      </div>
    </div>
  );
}

/** `variant="time"` -- clock only, no calendar. */
export function TimeFieldPanel({
  field,
  minuteStep,
  classNames,
  autoFocus,
}: DateTimePickerPanelProps) {
  const [hours, minutes] = field.timeParts;

  return (
    <TimePanel
      hours={hours}
      minutes={minutes}
      minuteStep={minuteStep}
      classNames={classNames}
      autoFocus={autoFocus}
      onChange={field.selectTime}
    />
  );
}
